<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
    >
    <template v-slot:activator="{ on }">
        <v-text-field
        v-model="formattedDate"
        :label="label"
        prepend-icon="event"
        readonly
        v-on="on"
        :append-icon="value != null && !required?'cancel':undefined"
        @click:append="erase"
        ></v-text-field>
        </template>
        <v-date-picker
        v-model="value" no-title @input="menu = false"
        :locale="$i18n.locale" first-day-of-week="1" ref="picker"></v-date-picker>
    </v-menu>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog,
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'FCCDate',
    data: () => ({
      menu: false,
      value: null
    }),
    computed: {
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      },
      formattedDate: function(){
        if(!this.value) return "";
        var parts = this.value.split('-');
        return parts[2]+"."+parts[1]+"."+parts[0];
      },
      originalValue: function(){
        if(this.source == null) return null;
        var v = this.source[this.propertyName];
        return v.split('T')[0];
      }
    },
    props: {
      source: Object,
      propertyName: String,
      label: String,
      required: Boolean
    },
    components: {
      VTooltip,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VTextarea
    },
    watch: {
      value (val) {
        if(this.source == null) return;
        this.source[this.propertyName] = val;
      },
      originalValue (val) {
        this.value = val;
      }
    },
    methods: {
      erase: function(){
        this.value = null;
      }
    }
  }
</script>